var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base_location_modal", {
    attrs: { tabs_advanced: _vm.tabs_add },
    scopedSlots: _vm._u([
      {
        key: "location_general_info",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("bolt_general_tab", { attrs: { location: location } })]
        },
      },
      {
        key: "bolt_work_hour",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("bolt_work_hour", { attrs: { location: location } })]
        },
      },
      {
        key: "bolt_labels",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("bolt_labels", { attrs: { location: location } })]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }